module.exports = __webpack_public_path__ + "static/media/essendon-logo.8d744578.svg";